import { useState } from 'react';
import './CircularCheckbox.css'

interface ICheckboxParams {
    label?: string;
    onChecked: (isChecked: boolean) => void;
    borderRadius?: string;
    isBold?:boolean;
}

const CircularCheckbox: React.FC<ICheckboxParams> = ({ label, onChecked, borderRadius='50%', isBold =true }) => {
    const [isChecked, setIsChecked] = useState(false);
    return (
        <div className="checkbox-wrapper">   
                <div className='round'>
                    <input type="checkbox" checked={isChecked} id="checkbox" onChange={() => { setIsChecked(!isChecked); onChecked(!isChecked) }} />
                    <label style={{borderRadius:`${borderRadius}`}} htmlFor="checkbox"></label>
                    {label && <span className={`ms-4 ps-2 ${isBold ? "fw-bold" : "fw-normal"}`}>{label}</span>}
                </div>
        </div>
    );
}
export default CircularCheckbox